var React = require('react');

function IconMultiples (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16.6623 5.2267L10.8289 1.88714C10.3155 1.5932 9.6845 1.5932 9.17107 1.88714L3.33774 5.2267C2.81959 5.52334 2.5 6.07417 2.5 6.6706V13.3294C2.5 13.9259 2.81959 14.4767 3.33774 14.7733L5 15.7246V9.16785L10 12.0205L15 9.16785V15.7238L16.6623 14.7733C17.1804 14.4767 17.5 13.9259 17.5 13.3294V6.6706C17.5 6.07417 17.1804 5.52334 16.6623 5.2267ZM13.3333 16.6783V12.1079L10 13.9945L6.66667 12.1079V16.6783L9.17107 18.1129C9.6845 18.4068 10.3155 18.4068 10.8289 18.1129L13.3333 16.6783Z","fill":"white"}));
}

IconMultiples.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = IconMultiples;

IconMultiples.default = IconMultiples;
